window.__forceSmoothScrollPolyfill__ = true;
const smoothscroll = require('smoothscroll-polyfill');

// kick off the polyfill!
smoothscroll.polyfill();